module.exports = __webpack_public_path__ + "assets/img/banner-19.cfe94940.jpg";